import { errorMiddleware } from './errorMiddleware';

export const links = [errorMiddleware];
